module.exports = __webpack_public_path__ + "img/Path 28@3x.a980a4b7.png";